<template>
  <!-- 首钢订单 -->
  <div class="app-container">
    <div ref="searchBox" class="formBox margbot">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px"
        size="mini">
        <div class="formItemBox">
          <!-- <el-form-item label="客户名称:" prop="customerName">
            <el-input placeholder v-model="searchFrom.customerName"></el-input>
          </el-form-item> -->
          <el-form-item label="合同编号:">
            <el-input placeholder v-model="searchFrom.contractNumber"></el-input>
          </el-form-item>
          <el-form-item label="地区订货用户:">
            <el-input placeholder v-model="searchFrom.regionalCompanyOrderName"></el-input>
          </el-form-item>
          <el-form-item label="最终用户:">
            <el-input placeholder v-model="searchFrom.endUserName"></el-input>
          </el-form-item>
          <el-form-item label="货权用户:">
            <el-input placeholder v-model="searchFrom.propertyUserName"></el-input>
          </el-form-item>
          <el-form-item label="质量归集用户:">
            <el-input placeholder v-model="searchFrom.qualityAggregation"></el-input>
          </el-form-item>
          <el-form-item label="需方用户:">
            <el-input placeholder v-model="searchFrom.demanderUserName"></el-input>
          </el-form-item>
          <el-form-item label="订单状态">
                <el-select v-model="searchFrom.status" placeholder="请选择订单状态" size="mini">
                  <el-option label="全部" value="">全部</el-option>
                  <el-option label="未完成" value="未完成">未完成 </el-option>
                  <el-option label="已完成" value="已完成">已完成 </el-option>
                </el-select>
              </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-button btnCode="003M4G0100" v-if="btnFlg[0]"  type="primary" size="mini" @click="searchFn">查 询
          </el-button>
          <el-button btnCode="003M4G0200" v-if="btnFlg[1]" type="primary" size="mini" @click="resetForm('searchFrom')">重 置
          </el-button>

          <el-button btnCode="003M4G0400" v-if="btnFlg[3]" type="primary" size="mini" @click="daoru('searchFrom')">导 入
          </el-button>
          <el-button  type="primary" size="mini" @click="xiazai('searchFrom')">下载模板
          </el-button>
          <el-button  type="primary" btnCode="003M4G0600" v-if="btnFlg[5]" size="mini" @click="daochu('searchFrom')">导出
          </el-button>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" bordersize="mini" @selection-change="selectGoods"  class="tableComent"
        @row-click="handleRowClick" height="100%" style="width: 100%" center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <div>
              <el-button btnCode="003M4G0300" v-if="btnFlg[2]" type="text" size="mini" @click="delFN(scope.row)">删除
              </el-button>
              <el-button btnCode="003M4G0500" v-if="btnFlg[4]" type="text" size="mini" @click="wancheng(scope.row)">标记完成
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="status" width="100" label="订单状态"></el-table-column>
        <el-table-column property="arrivalQuantity" width="120" label="累计入库（吨）"></el-table-column>
        <el-table-column property="outQuantity" width="120" label="累计出库（吨）"></el-table-column>
        <el-table-column property="contractNumber" width="120" label="合同号"></el-table-column>
        <el-table-column property="agreementNumber" width="120" label="合约号"></el-table-column>
        <el-table-column property="orderMonth" width="80" label="订货月份"></el-table-column>
        <el-table-column property="distributionChannel" width="100" label="销售渠道"></el-table-column>
        <el-table-column prop="orderPriority" label="订单优先级" width="120"></el-table-column>
        <el-table-column prop="regionalCompanyOrderName" width="120" label="地区公司订货用户名称"></el-table-column>
        <el-table-column prop="salesCollectionAbbreviation" width="120" label="销售归集用户简称"></el-table-column>
        <el-table-column prop="endUserName" width="120" label="最终用户名称"></el-table-column>
        <el-table-column prop="demanderUserName" width="120" label="需方用户名称"></el-table-column>
        <el-table-column prop="salespersonName" width="120" label="业务员姓名"></el-table-column>
        <el-table-column prop="receivingUserName" width="120" label="收货用户名称"></el-table-column>
        <el-table-column prop="propertyUserName" width="120" label="货权用户名称"></el-table-column>
        <el-table-column prop="qualityAggregation" width="120" label="质量归集用户名称"></el-table-column>
        <el-table-column prop="brandNo" width="80" label="牌号"></el-table-column>
        <el-table-column prop="productName" width="80" label="品名"></el-table-column>
        <el-table-column prop="productCate" width="120" label="产品分类描述"></el-table-column>
        <el-table-column prop="specification" width="120" label="规格描述"></el-table-column>
        <el-table-column prop="orderWeight" width="100" label="订货重量"></el-table-column>
        <el-table-column prop="orderQuantity" width="100" label="订货件/张数"></el-table-column>
        <el-table-column prop="waterproofAsk" width="120" label="加盖雨布要求"></el-table-column>
        <el-table-column prop="warehousingBin" width="100" label="入库仓位"></el-table-column>

      </el-table>
    </div>
    <!-- 分页 -->
    <div style="text-align: right;">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo" :page-sizes="[50, 100, 300,600,1000]" :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
    <!--点击导入按钮弹出框-->
    <daoru v-if="daoruMark" :daoruMark.sync="daoruMark"></daoru>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import daoru from './daoru.vue'
import DonMessage from '@/utils/message'
import {
  exportExcel
} from '@/utils/fileDown.js'
import {
  getSgOrderList,
  deleteSgOrder,
  accomplishSgOrder
} from '@/api/wms-stock'
export default {
  components: {
    daoru
  },
  data () {
    return {
      h: '500px',
      searchFrom: {
        status: '未完成',
        pageNo: 1,
        pageSize: 50
      },
      daoruMark: false,
      isDisable1: false,
      total: 0,
      tableList: [],
      btnFlg: [],
      btnIdArr: [
        '003M4G0100',
        '003M4G0200',
        '003M4G0300',
        '003M4G0400',
        '003M4G0500',
        '003M4G0600'
      ]
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/tracking')

    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 168 + 'px'
  },
  methods: {
    // 导出
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/tXhSgOrder/exXhSgOrder', {
          ...this.searchFrom
        },
        '首钢订单表'
      )
    },
    // 下载模板
    xiazai () {
      window.open(
        'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/template/wms/%E9%A6%96%E9%92%A2%E8%AE%A2%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx'
      )
    },
    daoru () {
      this.daoruMark = true
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.0
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })

      getSgOrderList(searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
        loading.close()
      }).catch((err) => {
        loading.close()
        DonMessage.error(err.message)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },

    // 删除
    delFN (row) {
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          deleteSgOrder({ id: row.id })
            .then(res => {
              loading.close()
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.getList(this.searchFrom)
            })
            .catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
        })
        .catch(() => { })
    },
    // 完成
    wancheng (row) {
      this.$confirm('是否执行标记完成操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          accomplishSgOrder({ id: row.id })
            .then(res => {
              loading.close()
              this.$message({
                message: '标记完成成功',
                type: 'success'
              })
              this.getList(this.searchFrom)
            })
            .catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
        })
        .catch(() => { })
    },

    // 重置
    resetForm (formName) {
      this.searchFrom = {
        status: '未完成',
        pageNo: 1,
        pageSize: 50
      }
      this.getList(this.searchFrom)
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null || cellValue == '') {
        str = '--'
      } else {
        str =
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
  margin-bottom: 10px;
}

.inpBox .el-date-editor {
  width: 350px !important;
}

.imgBox {
  display: flex;

  .item {
    display: flex;
    width: 50%;
    justify-content: space-around;
  }

  /deep/ .hide .el-upload--picture-card {
    display: none;
  }
}

.el-tag {
  margin: 0 4px !important;
}

.liuxiang /deep/ .el-input__inner {
  width: 100%;
}

.liuxiang /deep/.el-select {
  width: 417px;
}
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
